import { Event } from '../../types';
import DutyTooltipBody from './DutyTooltipBody';

interface EventTooltipProps {
  event: Event;
  onMouseOver?: () => void;
  multiplePlanUnitsSelected?: boolean;
}

const DutyTooltip = (props: EventTooltipProps) => {
  const { event, onMouseOver } = props;
  const periods = event.duty?.periods || [];
  const functionDescription = event.function?.description;
  const isIncludedInKidsRatio = event.duty?.isIncludedInKidsRatio;

  const {
    city,
    country,
    streetName,
    postalCode = ''
  } = event.duty?.assignedOrganizationalUnit?.address || {};

  const formattedAddress = [streetName, postalCode, city, country]
    .filter((f) => f)
    .join(', ');
  const address =
    event.duty?.assignedOrganizationalUnit?.address != null
      ? formattedAddress
      : undefined;

  const organizationName =
    event.duty?.assignedOrganizationalUnit?.name || undefined;

  return (
    <DutyTooltipBody
      onMouseOver={onMouseOver}
      periods={periods}
      isIncludedInKidsRatio={isIncludedInKidsRatio}
      multiplePlanUnitsSelected={props.multiplePlanUnitsSelected}
      organizationName={organizationName}
      address={address}
      functionDescription={functionDescription}
    />
  );
};

export default DutyTooltip;
